import { put, call, takeLatest, select } from 'redux-saga/effects';

import { addCustomGTMEvent } from '../../../events/googleTagManager';
import { formatError } from '../../../libs';
import searchAPI from '../../api/search';
import { Types, Creators } from '../../reducers/search';
import getState from '../../utils/getState';

function* searchRequest({ content }) {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);

    const data = yield call(
      searchAPI.search,
      {
        content,
        suggestionLimit: 7,
        productLimit: 3,
      },
      siteId
    );

    addCustomGTMEvent({ event: 'success_search', data: { search_term: content } });

    yield put(Creators.searchSuccess(data));

    if (data?.offers && data?.offers?.length) {
      yield put(Creators.searchInfosRequest(data.offers));
    }
  } catch (error) {
    yield put(Creators.searchFailed(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.SEARCH_REQUEST, searchRequest);
}
